import client from '../../client';

const endpoint = '/v2/global/sellers';


/**
 * Get all the sellers from the backend.
 * For more information please read the backend docs.
 */
export function getAll() {
  return client.get(endpoint).then(({ data }) => data)
}


export default {
  getAll,
}
